import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import imageDE from "../../../images/20231009_Druckpfahl Stahl_DE.png";
import imageEN from "../../../images/20231009_Druckpfahl Stahl_EN.png";
import imageES from "../../../images/20231009_Druckpfahl Stahl_ES.png";
import { berechneWandDicke } from "../../../services/berechnePileHead";
import { useGetTraggliedDatenQuery } from "../../../services/API/titanApi";
import { selectBemessungssituation, selectBerechneInnere } from "../../../store/slices/innereSlice";
import { selectTragglied } from "../../../store/slices/traggliedSlice";
import BestimmungDesUebergangsrohres from "./BestimmungDesUebergangsrohres/BestimmungDesUebergangsrohres";
import LageKopfplatteUndUbergangsrohr from "./LageKopfplatteUndUbergangsrohr/LageKopfplatteUndUbergangsrohr";

export default function DruckStahl() {
  const { t, i18n } = useTranslation("translation");

  // #region Redux Store Variables
  const tragglied = useSelector(selectTragglied);
  const bemessungssituation = useSelector(selectBemessungssituation);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied.title);
  const innereData = useSelector(selectBerechneInnere(traggliedDaten));
  // #endregion

  const [wandDicke, setWandDicke] = useState();

  useEffect(() => {
    let wanddicke = berechneWandDicke(
      bemessungssituation,
      traggliedDaten?.uebergangsrohr?.stahlrohr?.wanddicke
    );

    setWandDicke(wanddicke);
  }, [bemessungssituation, traggliedDaten]);

  return (
    <>
      <BestimmungDesUebergangsrohres
        traggliedDaten={traggliedDaten}
        durchmesserDesRohres={innereData?.durchmesserDesRohres}
        wanddickeUebergangsrohr={wandDicke}
        einbindelaengeBaugrund={Number(traggliedDaten?.uebergangsrohr?.min_lb_druck)}
        laenge={Number(traggliedDaten?.uebergangsrohr?.laenge_druck)}
      />

      <LageKopfplatteUndUbergangsrohr kopfkonstruktion={traggliedDaten?.kopfkonstruktion} />
      <br />
      <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <img
            src={i18n.language == "de-DE" ? imageDE : i18n.language == "es-ES" ? imageES : imageEN}
            style={{ width: "100%" }}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
